

import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { SocialProfile } from '../../models/socialprofile/socialprofile';
import { vxm } from './../../store.vuex';
import socialprofileValidator from './socialprofileValidator';
import { SocialProfileGroup } from '@/models/socialprofile/socialprofilegroup';
import ProfiePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
@Component({
  name: 'SocialProfiles',
  components: {
    placeholder: ProfiePlaceholder,
  },
})
export default class SocialProfiles extends Mixins(socialprofileValidator) {
  $wlToastr: any;
  private isViewMode: boolean = true;
  public currentSocialProfile: SocialProfile = new SocialProfile();
  public profileOptions: string[] = [];
  public profileLinkError: string = '';
  public socialProfileGroupList: SocialProfileGroup[] = [];
  public tempProfileid: number = -1;
  private socialProfilesToDelete: number[] = [];
  public dbSocialProfileGroupList: SocialProfileGroup[] = [];
  public profileErrrorMessages: any[] = [];
  async mounted() {
    this.refreshSocialProfiles();
  }

  async refreshSocialProfiles() {
    await vxm.socialprofiles.getSocialProfileData();
    this.socialProfileGroupList = vxm.socialprofiles.SocialProfileGroupList;
    this.dbSocialProfileGroupList = JSON.parse(
      JSON.stringify(this.socialProfileGroupList),
    );
    this.currentSocialProfile = new SocialProfile();
    this.profileErrrorMessages = [];
  }
  get userSocialProfileOptions() {
    return vxm.socialprofiles.SocialNetworksOptions.map((opt) => {
      return {
        id: opt,
        name: opt,
      };
    });
  }

  get sectionName() {
    if (this.$route.name && this.$route.name === 'GuidedSignup') {
      const section = vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
        (section) => section.sectionKey === 'SOCIAL_PROFILES',
      );
      return section ? section.displayName : 'Social Profiles';
    }
    const section = vxm.configs.ClientConfigs.userProfileConfig.profileSections.find(
      (section) => section.sectionKey === 'SOCIAL_PROFILES',
    );
    return section ? section.displayName : 'Social Profiles';
  }

  getImgUrl(name: string) {
    if (typeof name === 'undefined') return '';
    return require('../../assets/images2.0/myprofile-icons/brand_' +
      name.toLowerCase() +
      '.svg');
  }

  editSocialProfiles() {
    this.currentSocialProfile = new SocialProfile();
    this.isViewMode = false;
    this.tempProfileid = -1;
  }

  async addSocialProfile() {
    if (this.validateForm()) {
      var itemFound = false;
      this.socialProfileGroupList.forEach((item, index) => {
        if (item.name === this.currentSocialProfile.name) {
          var tempSocialProfile = new SocialProfile();
          tempSocialProfile.id = this.tempProfileid;
          tempSocialProfile.name = this.currentSocialProfile.name;
          tempSocialProfile.profileLink = this.currentSocialProfile.profileLink.trim();
          item.details.push(tempSocialProfile);
          itemFound = true;
        }
      });
      if (!itemFound) {
        var tempsocialProfileGroup = new SocialProfileGroup();
        tempsocialProfileGroup.name = this.currentSocialProfile.name;
        var tempSocialProfile = new SocialProfile();
        tempSocialProfile.id = this.tempProfileid;
        tempSocialProfile.name = this.currentSocialProfile.name;
        tempSocialProfile.profileLink = this.currentSocialProfile.profileLink.trim();
        tempsocialProfileGroup.details.push(tempSocialProfile);
        this.socialProfileGroupList.push(tempsocialProfileGroup);
      }
      this.currentSocialProfile.name = '';
      this.currentSocialProfile.profileLink = '';
      this.tempProfileid--;
      this.socialProfileGroupList.forEach((item, index) => {
        item.details.forEach((item2, index2) => {
          console.log(
            'id:' +
              item2.id +
              ' item2.name:' +
              item2.name +
              'item2.profileLink:' +
              item2.profileLink,
          );
        });
      });
      console.log('-----------------------------');
    }
  }

  async deleteSocialProfile(id: number) {
    console.log('deleting social profile:' + id);
    this.socialProfileGroupList.forEach((item, index) => {
      item.details.forEach((item2, index2) => {
        if (item2.id === id) {
          item.details.splice(index2, 1);
          if (id > 0) {
            this.socialProfilesToDelete.push(id);
          }
        }
      });
      if (item.details.length == 0)
        this.socialProfileGroupList.splice(index, 1);
    });
  }

  userPermissionConfig(permission) {
    return vxm.configs.getUserPermissionConfig(permission, 'SOCIAL_PROFILES');
  }

  cancelUpdate() {
    console.log('cancel update called');
    this.isViewMode = true;
    this.socialProfileGroupList = [];
    this.socialProfileGroupList = JSON.parse(
      JSON.stringify(this.dbSocialProfileGroupList),
    );
  }

  async saveUpdateSocialProfiles() {
    if (this.isValidSocialProfiles()) {
      const vm = this;
      let respPromise: any;
      if (this.socialProfilesToDelete.length > 0) {
        respPromise = vxm.socialprofiles.deleteSocialProfiles(
          this.socialProfilesToDelete,
        );
        Promise.all([respPromise]).then(async (values) => {
          if (values[0].meta.success) {
            console.log('delete succes............');
          } else {
            vm.$wlToastr(
              'error',
              values[0].meta.error.detailedMessage,
              vm.$t('socialprofile.profileedit.heading'),
            );
          }
        });
      }
      let respPromise1: any;
      let tempsocialProfileList: SocialProfile[] = [];
      this.socialProfileGroupList.forEach((item, index) => {
        item.details.forEach((item2, index2) => {
          var tempProfile = new SocialProfile();
          tempProfile.name = item2.name;
          tempProfile.profileLink = item2.profileLink.trim();
          if (item2.id > 0) tempProfile.id = item2.id;
          tempsocialProfileList.push(tempProfile);
        });
      });
      respPromise1 = vxm.socialprofiles.saveUpdateSocialProfileDataList(
        tempsocialProfileList,
      );
      Promise.all([respPromise1]).then(async (values) => {
        if (values[0].meta.success) {
          console.log('succes............');
          this.refreshSocialProfiles();
          this.isViewMode = true;

          if (
            JSON.stringify(this.socialProfileGroupList) !=
            JSON.stringify(this.dbSocialProfileGroupList)
          )
            vxm.users.Rudderstack.trackEvent("Updated Social Profiles", {
              SocialProfileList : tempsocialProfileList
            } )
            vm.$wlToastr(
              'success',
              vm.$t('socialprofile.updated.successfully'),
              vm.$t('socialprofile.profileedit.heading'),
            );
        } else {
          vm.$wlToastr(
            'error',
            values[0].meta.error.detailedMessage,
            vm.$t('socialprofile.profileedit.heading'),
          );
        }
        vxm.users.getProfileStrength();
      });
    }
  }

  isValidSocialProfiles(): boolean {
    this.profileErrrorMessages = [];
    if (
      this.socialProfileGroupList.length > 0 ||
      this.dbSocialProfileGroupList.length > 0
    ) {
      this.socialProfileGroupList.forEach((item, index) => {
        item.details.forEach((item2, index2) => {
          if (!this.validateFormNew(item2, this.socialProfileGroupList)) {
            this.profileErrrorMessages.push({
              id: item2.id,
              message: 'socialprofile.profilelink.urlexists',
            });
          } else {
            const errorMessage = this.isInValidSocialProfilelink(
              item2.name,
              item2.profileLink,
            );
            if (errorMessage) {
              this.profileErrrorMessages.push({
                id: item2.id,
                message: errorMessage,
              });
            }
          }
        });
      });
      if (this.currentSocialProfile.profileLink) {
        this.profileLinkError = 'socialprofile.user.plus.to.add.social.profile';
        return false;
      } else {
        this.profileLinkError = '';
      }
    } else {
      this.profileLinkError = 'socialprofile.profile.emptyprofiles';
      return false;
    }
    if (this.profileErrrorMessages.length > 0) {
      return false;
    }
    return true;
  }

  validateForm() {
    if (
      !this.validateFormNew(
        this.currentSocialProfile,
        this.socialProfileGroupList,
      )
    ) {
      this.profileLinkError = 'socialprofile.profilelink.urlexists';
      return false;
    } else {
      this.profileLinkError = this.isInValidSocialProfilelink(
        this.currentSocialProfile.name,
        this.currentSocialProfile.profileLink,
      );
      return this.profileLinkError ? false : true;
    }
  }

  checkProfileIdErrorValue(profileId: number): string {
    if (this.profileErrrorMessages.length > 0) {
      const result = this.profileErrrorMessages.find(
        (ele) => ele.id === profileId,
      );
      if (typeof result != 'undefined') {
        return result.message;
      }
    }
    return '';
  }
  addUpdateSocialProfiles() { 
if(this.currentSocialProfile.name) this.addSocialProfile();
   this.saveUpdateSocialProfiles();
      }
}
